import styled from "styled-components";
import {useRef, useState, useEffect} from "react";
import {SatelliteDroparea} from "satellite-droparea";
import ReactDOM from "react-dom";
import useOnClickOutside from "../../../hooks/useOnClickOutside";

export const IntPortalSlot = (
  {
    isOpen,
    children,
    content,
    outsideTarget = null,
    excludeClickOutsideElements = [],
    dropdownWidth = null,
    onClose = () => {}
  }
) => {

  const [show, setShow] = useState(isOpen);
  const dropper = useRef(null);
  const target = useRef(null);

  const toggle = () => setShow(!show);


  const stopId = useRef(0);
  let satellite = null;

  useEffect(() => {
    return () => {
      satellite = null;
      clearInterval(stopId.current);
    }

  }, []);

  useEffect(() => {
    if(!isOpen) {
      clearInterval(stopId.current);
    }else{
      const config = {
        target: outsideTarget || target.current,
        viewport: document.body,
        dropper: dropper.current,
        verticalOffset: 10,
        horizontalOffset: 0,
        viewportOffset: 10,
        customDropWidth: dropdownWidth,
        verticalAlign: 'center',
        horizontalAlign: 'start',
        positionSteps: ['bottom', 'top']
      }
      satellite = new SatelliteDroparea(config);

      updateCoords(satellite, dropper);
      stopId.current = setInterval(() => {
        updateCoords(satellite, dropper);
      }, 2000)
    }
  }, [isOpen]);

  const updateCoords = (satellite, dropper) => {
    if(satellite && dropper) {
      const {top, left, width} = satellite.getDropAreaOutputData();
      if(dropper) {
        dropper.current.style.top = `${top}px`;
        dropper.current.style.left = `${left}px`;
        dropper.current.style.width = `${width}px`;
      }
    }
  }

  useOnClickOutside([...excludeClickOutsideElements, dropper], () => {
    setShow(false);
    onClose();
  })


  return <Container ref={target} onClick={() => toggle()} data-element={`int-target-dropdown`}>
    { children }
    {
      ReactDOM.createPortal(
        <DropArea ref={dropper}>
          <div>
            {
              isOpen ?  content  : null
            }
          </div>
        </DropArea>,
        document.body
      )
    }

  </Container>
}

const Container = styled.div`
  cursor: pointer;
`;
const DropArea = styled.div`
  position: fixed;
`;